import { useRecentLookups } from "@homesite/hooks";
import { LoanLookupPage } from "@homesite/ui";
import { createRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { rootRoute } from "./__root";

export const loanLookupRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/loans",
	component: function LoanLookup() {
		const navigate = useNavigate();
		const [searchValue, setSearchValue] = useState("");
		const { recent, remember } = useRecentLookups();

		function handleSubmit(): void {
			const trimmed = searchValue.trim();
			if (!trimmed) return;
			remember(trimmed);
			void navigate({ to: "/loans/$loanId", params: { loanId: trimmed } });
		}

		return (
			<LoanLookupPage
				searchValue={searchValue}
				onSearchChange={setSearchValue}
				onSubmit={handleSubmit}
				recentLookups={recent}
			/>
		);
	},
});
